"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var icons_1 = require("../../../../../icons");
var variables_1 = require("../../../../../style/variables");
var layout_1 = require("../../../../layout");
var SelectSingleValue_1 = require("../SelectSingleValue");
var Tooltip_1 = __importDefault(require("../../../../Tooltip"));
var styles = {
    container: {
        default: react_1.css({
            cursor: 'pointer',
            padding: '8px 12px',
            overflow: 'hidden',
            background: "var(" + variables_1.RootColor.White + ")",
            '.icon': {
                color: "var(" + variables_1.RootColor.Gray.DEFAULT + ")",
            },
            ':hover': {
                backgroundColor: "var(" + variables_1.RootColor.Gray.LIGHT_5 + ")",
                '.icon': {
                    color: "var(" + variables_1.RootColor.Gray.DARK_2 + ")",
                },
            },
        }),
        disabled: react_1.css({
            backgroundColor: "var(" + variables_1.RootColor.Gray.LIGHT_6 + ")",
            ':hover': {
                backgroundColor: "var(" + variables_1.RootColor.Gray.LIGHT_6 + ")",
            },
            '.icon': {
                color: "var(" + variables_1.RootColor.Gray.LIGHT_1 + ")",
            },
        }),
        selected: react_1.css({
            backgroundColor: "var(" + variables_1.ThemeColor.Primary.LIGHT_6 + ")",
            ':hover': {
                backgroundColor: "var(" + variables_1.ThemeColor.Primary.LIGHT_6 + ")",
                '.icon': {
                    color: "var(" + variables_1.RootColor.Gray.DARK_2 + ")",
                },
            },
        }),
        focused: react_1.css({
            // boxShadow: `var(${Focus.PRIMARY_LIGHT})`,
            backgroundColor: "var(" + variables_1.RootColor.Gray.LIGHT_5 + ")",
            '.icon': {
                color: "var(" + variables_1.RootColor.Gray.DARK_2 + ")",
            },
        }),
    },
};
var SelectMenuItem = function (props) {
    var disabled = props.disabled, focused = props.focused, selected = props.selected, tooltipText = props.tooltipText;
    return (react_1.jsx(Tooltip_1.default, { overlay: tooltipText, placement: "left" },
        react_1.jsx(layout_1.Flex, { gap: 8, alignItems: "center", css: [
                styles.container.default,
                focused ? styles.container.focused : undefined,
                selected ? styles.container.selected : undefined,
                disabled ? styles.container.disabled : undefined,
            ] },
            react_1.jsx(SelectSingleValue_1.SingleValueLeading, __assign({}, props, { size: "md" })),
            react_1.jsx(layout_1.Flex, { alignItems: "center", css: { flex: 1, overflow: 'hidden', whiteSpace: 'nowrap' } },
                react_1.jsx(SelectSingleValue_1.SingleValueText, __assign({}, props, { size: "md" }))),
            selected ? (react_1.jsx(icons_1.Check, { size: 20, color: "var(" + (disabled ? variables_1.TextColor.DISABLED : variables_1.ThemeColor.Primary.DARK_2) + ")" })) : null)));
};
exports.default = SelectMenuItem;
